module.exports = __webpack_public_path__ + "img/image-question.f57bb613.svg";